/**
 * Transforms getUser response from the LOCAL backend.
 * The backend already returns structured data (iamTenant, userTenants, etc.)
 * so we only need to derive a few display fields.
 */
export const transformUserData = (user) => {
    if (!user) return null;

    const firstName = user.firstName || '';
    const lastName = user.lastName || '';

    // Derive "fullName" — use backend's fullName if available, else build it
    const fullName = user.fullName
        || `${firstName} ${lastName}`.trim()
        || user.email
        || '';

    // Derive "initials" — use backend's initials if available, else build it
    const initials = user.initials
        || `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
        || '??';

    // userStatus — prefer direct field, fallback to iamUserStatus
    const userStatus = user.userStatus || user.iamUserStatus || '';

    // moduleIds — backend returns this directly now
    const moduleIds = user.moduleIds || [];

    // iamTenant — backend returns this as a joined object
    // Provide a safe fallback to prevent "Cannot read property of null"
    const iamTenant = user.iamTenant || {
        tenantId: null,
        name: null,
        type: null,
        domainUrls: null,
        iamOrganizationId: null,
        iamAllowedDomains: null,
        iamRestrictedDomains: null,
        iamOnboardOrganizationAdmin: null,
        iamStatus: null,
    };

    // userTenants — backend returns this as joined array
    const userTenants = user.userTenants || [];

    return {
        ...user,
        fullName,
        initials,
        moduleIds,
        userStatus,
        userTenants,
        iamTenant,
    };
};